import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	container: {
		width: "100%",
		minHeight: "100vh",
		padding: "0 24px"
	},
	logo: {
		display: "block",
		margin: "0 auto",
		maxWidth: "120px",
		height: "auto"
	},
	title: {
		color: colors.gray[800],
		fontWeight: 600
	},
	subtitle: {
		color: colors.gray[500],
		textAlign: "center",
		maxWidth: "400px"
	}
})

export default useStyles
